export const EXCMCARUSERDATA_CREATE_RESET = 'EXCMCARUSERDATA_CREATE_RESET'
export const EXCMCARUSERDATA_CREATE_SET_CREATED = 'EXCMCARUSERDATA_CREATE_SET_CREATED'
export const EXCMCARUSERDATA_CREATE_SET_ERROR = 'EXCMCARUSERDATA_CREATE_SET_ERROR'
export const EXCMCARUSERDATA_CREATE_SET_VIOLATIONS = 'EXCMCARUSERDATA_CREATE_SET_VIOLATIONS'
export const EXCMCARUSERDATA_CREATE_TOGGLE_LOADING = 'EXCMCARUSERDATA_CREATE_TOGGLE_LOADING'
